import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { List, Button } from "antd";
import moment from "moment";

import ExerRecordPane from "./ExerRecordPane";
import NoneData from "../common/NoneData";
export class ExerRecordMyWrong extends Component {
  state = {
    curPage: 1,
    questionType: -1,
    questionTypeName: "",
    checkIndex: -1,
  }
  static propTypes = {
    center: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentDidMount() {
    this.props.actions.fetchGetQuestionTypeList().then(res => {
      if (res.SuccessResponse) {
        this.setState({
          questionType: res.Data[0].ID,
          questionTypeName: res.Data[0].Name
        }, () => {
          this.onLoadMyWrong();
        })
      }
    })
  }
  onLoadMyWrong() {
    this.props.actions.fetchGetMyWrongQuestion({
      PageSize: 5,
      PageIndex: this.state.curPage,
      PageStatus: 1,
      QuestionType_ID: this.state.questionType,
    })
  }
  onWrongTypeClick(data) {
    this.setState({
      curPage: 1,
      questionType: data.ID,
      questionTypeName: data.Name
    }, () => {
      this.onLoadMyWrong();
    })
  }
  renderItem(item, key, questionTypeName) {
    const { checkIndex } = this.state;
    return (
      <div key={key} className="wrong-collect-item">
        <div className="wrong-collect-item-content">
          <h1>
            <p>【{questionTypeName}】<span dangerouslySetInnerHTML={{ __html: item.Title }} /></p>
            <p>{moment(new Date(item.UpdateTime)).format("YYYY-MM-DD HH:mm:ss")}</p>
          </h1>
          <div className="btns">
            <Button className="btn" type="theme" onClick={() => {
              if (checkIndex === item.ID) {
                this.setState({
                  checkIndex: -1,
                })
              } else {
                this.setState({
                  checkIndex: item.ID,
                })
              }
            }}>{checkIndex === item.ID ? "收起错题" : "查看错题"}</Button>
          </div>
        </div>
        {
          checkIndex === item.ID &&
          <ExerRecordPane
            {...this.props}
            item={item}
            questionTypeName={questionTypeName}
            onLoad={this.onLoadMyWrong.bind(this)}
          />
        }
      </div>
    )
  }
  render() {
    let { fetchGetQuestionTypeListSuccess,
      fetchGetMyWrongQuestionPending,
      fetchGetMyWrongQuestionSuccess,
      fetchGetMyWrongQuestionTotal } = this.props.center;
    const { questionType, questionTypeName } = this.state;
    if (fetchGetQuestionTypeListSuccess) {
      fetchGetQuestionTypeListSuccess = fetchGetQuestionTypeListSuccess.filter(item => {
        return ["单选题", "多选题", "判断题"].indexOf(item.Name) !== -1;
      })
    }
    return (
      <div className="center-exer-record-my-wrong">
        <div className="inner">
          {
            fetchGetQuestionTypeListSuccess && fetchGetQuestionTypeListSuccess.length > 0 &&
            <div className="wrong-type">
              {
                fetchGetQuestionTypeListSuccess.map(item => (
                  <div
                    key={item.ID}
                    onClick={this.onWrongTypeClick.bind(this, item)}
                    className={questionType === item.ID ? "wrong-type-item-active" : "wrong-type-item"}
                  >
                    {item.Name}
                  </div>
                ))
              }

            </div>
          }
          {
            fetchGetMyWrongQuestionSuccess && fetchGetMyWrongQuestionSuccess.length > 0 &&
            <div className="wrong-collect-list">
              <List
                itemLayout="horizontal"
                size="large"
                pagination={{
                  onChange: page => {
                    this.setState({
                      curPage: page,
                    }, () => {
                      this.onLoadMyWrong();
                    })
                  },
                  current: this.state.curPage,
                  total: fetchGetMyWrongQuestionTotal,
                  pageSize: 5,
                }}
                loading={fetchGetMyWrongQuestionPending}
                dataSource={fetchGetMyWrongQuestionSuccess}
                renderItem={(item, key) => this.renderItem(item, key, questionTypeName)}
              />
            </div>
          }
          {
            fetchGetMyWrongQuestionSuccess && fetchGetMyWrongQuestionSuccess.length === 0 &&
            <div className="noneData">
              <NoneData type={2} />
            </div>
          }
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    center: state.center,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExerRecordMyWrong);



// WEBPACK FOOTER //
// ./src/features/center/ExerRecordMyWrong.js